import React from 'react';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import EmployeeActions from 'actions/EmployeeActions.js';
import UserActions from 'actions/UserActions.js';

class SidebarDropBid extends React.Component {
  constructor(props) {
    super(props);

    this.onLoadUserData = this.onLoadUserData.bind(this);
    this.onAcceptOffer = this.onAcceptOffer.bind(this);
    this.loadingShift = true;

    this.state = {
      user: {},
      loaded: false,
    };
  }

  hasAllLoaded() {
    if (!this.loadingUser) {
      this.setState({
        loaded: true,
      });
    }
  }

  componentWillUnmount() {
    UserStore.off('user:load:success', this.onLoadUserData);
  }

  componentDidMount() {
    const userData = ExchangesStore.getExchangeUser(this.props.bidData.user_id);
    // Why would the user data be empty? Commenting out for now.
    // if (_.isEmpty(userData)) {
    //   UserActions.getUser(this.props.bidData.user_id);
    //   UserStore.on('user:load:success', this.onLoadUserData);
    // } else {
    //   this.loadingUser = false;
    // }
    this.loadingUser = false;

    this.setState({
      user: userData,
    });

    this.hasAllLoaded();
  }

  onAcceptOffer(e) {
    if (EmployeeActions) {
      EmployeeActions.acceptBidOffer(
        this.props.bidData.exchange_id,
        this.props.bidData.id,
        this.props.bidData.user_id,
        null,
        true,
      );
    }
  }

  onLoadUserData(response) {
    if (response.id == this.props.bidData.user_id) {
      this.setState({
        user: response,
      });
      this.loadingUser = false;
      this.hasAllLoaded();
    }
  }

  render() {
    if (!this.state.loaded || Utils.isNotDefined(this.state.user)) {
      return false;
    }

    const relatedExchangeData = ExchangesStore.getAdvertisementByExchangeID(
      this.props.bidData.exchange_id,
    );
    const relatedShiftData = relatedExchangeData.shift_details;

    let acceptButton = (
      <button
        className="calendar-input-button accept-offer"
        onClick={e => this.onAcceptOffer(e)}
        key={_.uniqueId()}
      >
        {this.props.t('SidebarDropBid.accept')}
      </button>
    );
    if (
      this.props.bidData.user_id == Utils.getCoreUser().id
      || !Utils.isNotDefined(relatedExchangeData.accepted_user_id)
    ) {
      acceptButton = [];
    }

    let shiftName = '';
    let shiftStartTime = '';
    let shiftTimeBlock = '';
    if (!Utils.isNotDefined(relatedShiftData)) {
      shiftName = relatedShiftData.name;
      shiftTimeBlock = `${moment(relatedShiftData.start_time)
        .tz(relatedShiftData.time_zone)
        .format('h:mm a')} - ${moment(relatedShiftData.end_time)
        .tz(relatedShiftData.time_zone)
        .format('h:mm a')}`;
      const momentObj = moment(relatedShiftData.start_time)
        .tz(relatedShiftData.time_zone)
      shiftStartTime = Utils.formatLocaleDate(momentObj);
    }

    const shiftLabel = this.props.accepted ? this.props.t('SidebarDropBid.accepted_offer') : this.props.t('SidebarDropBid.drop_offer');
    let breaks = null;
    let notes = null;

    if (!Utils.isNotDefined(relatedShiftData) && !Utils.isNotDefined(relatedShiftData.breaks)) {
      breaks = Utils.formatUnformattedBreaks(relatedShiftData.breaks);
    }

    if (
      !Utils.isNotDefined(relatedShiftData)
      && !Utils.isNotDefined(relatedShiftData.shift_notes)
    ) {
      notes = relatedShiftData.shift_notes;
    }

    return (
      <div className="calendar-input exchange-offer">
        <span className="calendar-input-bullet exchange">{shiftLabel}</span>
        <div className="shift-detail-content">
          <p className="shift-detail-title">
            {this.state.user.name}
            <br />
            {shiftStartTime}
            <br />
            {shiftTimeBlock}
          </p>

          {!Utils.isNotDefined(breaks) && (
            <p className="shift-detail-breaks">
              {this.props.t('SidebarDropBid.breaks')}:&nbsp;
              {breaks}
            </p>
          )}

          {!Utils.isNotDefined(relatedShiftData) && (
            <ShiftDetailBlock
              locationID={relatedShiftData.location_id}
              departmentID={relatedShiftData.department_id}
              position={relatedShiftData.position}
              job_site_name={relatedShiftData.job_site_name}
              job_site_address={relatedShiftData.job_site_address}
              active="true"
            />
          )}
          {!Utils.isNotDefined(notes) && (
            <div className="shift-detail-notes-container">
              <p className="shift-detail-title">{this.props.t('SidebarDropBid.notes').toUpperCase()}</p>
              <p className="shift-detail-notes">{notes}</p>
            </div>
          )}
        </div>
        <div className="full-flex-container exchange-buttons">{acceptButton}</div>
      </div>
    );
  }
}

export default translate()(SidebarDropBid);
